import {
  NORMALIZED_NAME_INPUT,
  isValidDate,
  EMAIL_REGEX,
  isValidPhoneNumber
} from './benefitsProvider'

export const inputValidations = (field, value, formData) => {
  if (!field || !value) {
    return
  }
  switch (field) {
    case 'firstName':
      if (formData?.firstName?.length < 2) {
        return { memberId: 'First Name must be at least 2 characters long' }
      }
      return NORMALIZED_NAME_INPUT.test(value)
        ? { firstName: null }
        : { firstName: 'Please enter a valid first name' }
    case 'lastName':
      if (formData?.lastName?.length < 2) {
        return { memberId: 'Last Name must be at least 2 characters long' }
      }
      return NORMALIZED_NAME_INPUT.test(formData.lastName)
        ? { lastName: null }
        : { lastName: 'Please enter a valid last name' }
    case 'dob':
      return isValidDate(value)
        ? { dob: null }
        : {
            dob: 'Please enter a valid date that is after 1914. Ex: 12/31/1980'
          }
    case 'email':
      return EMAIL_REGEX.test(value)
        ? { email: null }
        : { email: 'Please enter a valid email address' }
    case 'phone':
      return isValidPhoneNumber(value)
        ? { phone: null }
        : { phone: 'Please enter a valid phone number' }
    case 'insuranceCompany':
      return formData.payerId
        ? { insuranceCompany: null }
        : {
            insuranceCompany:
              'Please select an insurance provider from the list'
          }
    case 'memberId':
      if (formData?.memberId?.length < 6) {
        return { memberId: 'Member ID must be at least 6 characters long' }
      }
      return NORMALIZED_NAME_INPUT.test(formData.memberId)
        ? { memberId: null }
        : { memberId: 'Please enter a valid member ID' }
    default:
      return { [field]: null }
  }
}
